var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStackedbarchartThumb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 952,
    height: 794,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "full",
    viewBox: "0 0 952 794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 952,
    height: 794,
    x: 0,
    y: 0,
    id: 0,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.2 694.5L856.8 694.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2 567.5L856.8 567.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2 440.5L856.8 440.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2 313.5L856.8 313.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2 187.5L856.8 187.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2 60.5L856.8 60.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2 694.5L856.8 694.5",
    fill: "none",
    stroke: "#6E7079",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    xmlSpace: "preserve",
    transform: "translate(871.8 694)",
    fill: "#6E7079"
  }, "X Axis"), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5 694L95.5 699",
    fill: "none",
    stroke: "#6E7079"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M171.5 694L171.5 699",
    fill: "none",
    stroke: "#6E7079"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M247.5 694L247.5 699",
    fill: "none",
    stroke: "#6E7079"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M323.5 694L323.5 699",
    fill: "none",
    stroke: "#6E7079"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M400.5 694L400.5 699",
    fill: "none",
    stroke: "#6E7079"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M476.5 694L476.5 699",
    fill: "none",
    stroke: "#6E7079"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M552.5 694L552.5 699",
    fill: "none",
    stroke: "#6E7079"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M628.5 694L628.5 699",
    fill: "none",
    stroke: "#6E7079"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M704.5 694L704.5 699",
    fill: "none",
    stroke: "#6E7079"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M780.5 694L780.5 699",
    fill: "none",
    stroke: "#6E7079"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M857.5 694L857.5 699",
    fill: "none",
    stroke: "#6E7079"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(87.2 694)",
    fill: "#6E7079"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(87.2 567.2)",
    fill: "#6E7079"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(87.2 440.4)",
    fill: "#6E7079"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(87.2 313.6)",
    fill: "#6E7079"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(87.2 186.8)",
    fill: "#6E7079"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(87.2 60)",
    fill: "#6E7079"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(133.28 702)",
    fill: "#6E7079"
  }, "Class0"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(209.44 702)",
    fill: "#6E7079"
  }, "Class1"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(285.6 702)",
    fill: "#6E7079"
  }, "Class2"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(361.76 702)",
    fill: "#6E7079"
  }, "Class3"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(437.92 702)",
    fill: "#6E7079"
  }, "Class4"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(514.08 702)",
    fill: "#6E7079"
  }, "Class5"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(590.24 702)",
    fill: "#6E7079"
  }, "Class6"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(666.4 702)",
    fill: "#6E7079"
  }, "Class7"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(742.56 702)",
    fill: "#6E7079"
  }, "Class8"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(818.72 702)",
    fill: "#6E7079"
  }, "Class9"), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M105.4816 694l25.2713 0l0 -101.44l-25.2713 0Z",
    fill: "rgb(84,112,198)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M181.6416 694l25.2713 0l0 -49.452l-25.2713 0Z",
    fill: "rgb(84,112,198)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M257.8016 694l25.2713 0l0 -7.608l-25.2713 0Z",
    fill: "rgb(84,112,198)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M333.9616 694l25.2713 0l0 -216.828l-25.2713 0Z",
    fill: "rgb(84,112,198)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M410.1216 694l25.2713 0l0 -147.088l-25.2713 0Z",
    fill: "rgb(84,112,198)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M486.2816 694l25.2713 0l0 -20.288l-25.2713 0Z",
    fill: "rgb(84,112,198)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M562.4416 694l25.2713 0l0 -43.112l-25.2713 0Z",
    fill: "rgb(84,112,198)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M638.6016 694l25.2713 0l0 -248.528l-25.2713 0Z",
    fill: "rgb(84,112,198)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M714.7616 694l25.2713 0l0 -181.324l-25.2713 0Z",
    fill: "rgb(84,112,198)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M790.9216 694l25.2713 0l0 -109.048l-25.2713 0Z",
    fill: "rgb(84,112,198)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M105.4816 592.56l25.2713 0l0 -328.412l-25.2713 0Z",
    fill: "rgb(145,204,117)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M181.6416 644.548l25.2713 0l0 -83.688l-25.2713 0Z",
    fill: "#91cc75"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M257.8016 686.392l25.2713 0l0 -434.924l-25.2713 0Z",
    fill: "#91cc75"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M333.9616 477.172l25.2713 0l0 -109.048l-25.2713 0Z",
    fill: "#91cc75"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M410.1216 546.912l25.2713 0l0 -31.7l-25.2713 0Z",
    fill: "#91cc75"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M486.2816 673.712l25.2713 0l0 -410.832l-25.2713 0Z",
    fill: "#91cc75"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M562.4416 650.888l25.2713 0l0 -540.168l-25.2713 0Z",
    fill: "#91cc75"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M638.6016 445.472l25.2713 0l0 -45.648l-25.2713 0Z",
    fill: "#91cc75"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M714.7616 512.676l25.2713 0l0 -339.824l-25.2713 0Z",
    fill: "#91cc75"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M790.9216 584.952l25.2713 0l0 -408.296l-25.2713 0Z",
    fill: "#91cc75"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M135.8071 694l25.2713 0l0 -124.264l-25.2713 0Z",
    fill: "#fac858"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M211.9671 694l25.2713 0l0 -67.204l-25.2713 0Z",
    fill: "#fac858"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M288.1271 694l25.2713 0l0 -88.76l-25.2713 0Z",
    fill: "#fac858"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M364.2871 694l25.2713 0l0 -98.904l-25.2713 0Z",
    fill: "#fac858"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M440.4471 694l25.2713 0l0 -135.676l-25.2713 0Z",
    fill: "#fac858"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M516.6071 694l25.2713 0l0 -128.068l-25.2713 0Z",
    fill: "#fac858"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M592.7671 694l25.2713 0l0 -76.08l-25.2713 0Z",
    fill: "#fac858"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M668.9271 694l25.2713 0l0 -96.368l-25.2713 0Z",
    fill: "#fac858"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M745.0871 694l25.2713 0l0 -92.564l-25.2713 0Z",
    fill: "#fac858"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M821.2471 694l25.2713 0l0 -72.276l-25.2713 0Z",
    fill: "#fac858"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M135.8071 569.736l25.2713 0l0 -24.092l-25.2713 0Z",
    fill: "#ee6666"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M211.9671 626.796l25.2713 0l0 -46.916l-25.2713 0Z",
    fill: "#ee6666"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M288.1271 605.24l25.2713 0l0 -67.204l-25.2713 0Z",
    fill: "#ee6666"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M364.2871 595.096l25.2713 0l0 -103.976l-25.2713 0Z",
    fill: "#ee6666"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M440.4471 558.324l25.2713 0l0 -34.236l-25.2713 0Z",
    fill: "#ee6666"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M516.6071 565.932l25.2713 0l0 -21.556l-25.2713 0Z",
    fill: "#ee6666"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M592.7671 617.92l25.2713 0l0 -29.164l-25.2713 0Z",
    fill: "#ee6666"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M668.9271 597.632l25.2713 0l0 -19.02l-25.2713 0Z",
    fill: "#ee6666"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M745.0871 601.436l25.2713 0l0 -27.896l-25.2713 0Z",
    fill: "#ee6666"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M821.2471 621.724l25.2713 0l0 -65.936l-25.2713 0Z",
    fill: "#ee6666"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M-5 -5l249.3965 0l0 24l-249.3965 0Z",
    transform: "translate(100.2 5)",
    fill: "rgb(0,0,0)",
    fillOpacity: 0,
    stroke: "#ccc",
    strokeWidth: 0
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0L21.5 0A3.5 3.5 0 0 1 25 3.5L25 10.5A3.5 3.5 0 0 1 21.5 14L3.5 14A3.5 3.5 0 0 1 0 10.5L0 3.5A3.5 3.5 0 0 1 3.5 0",
    transform: "translate(100.2 5)",
    fill: "#5470c6"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    x: 30,
    y: 7,
    transform: "translate(100.2 5)",
    fill: "#333"
  }, "bar"), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0L21.5 0A3.5 3.5 0 0 1 25 3.5L25 10.5A3.5 3.5 0 0 1 21.5 14L3.5 14A3.5 3.5 0 0 1 0 10.5L0 3.5A3.5 3.5 0 0 1 3.5 0",
    transform: "translate(157.5438 5)",
    fill: "#91cc75"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    x: 30,
    y: 7,
    transform: "translate(157.5438 5)",
    fill: "#333"
  }, "bar2"), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0L21.5 0A3.5 3.5 0 0 1 25 3.5L25 10.5A3.5 3.5 0 0 1 21.5 14L3.5 14A3.5 3.5 0 0 1 0 10.5L0 3.5A3.5 3.5 0 0 1 3.5 0",
    transform: "translate(221.5613 5)",
    fill: "#fac858"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    x: 30,
    y: 7,
    transform: "translate(221.5613 5)",
    fill: "#333"
  }, "bar3"), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0L21.5 0A3.5 3.5 0 0 1 25 3.5L25 10.5A3.5 3.5 0 0 1 21.5 14L3.5 14A3.5 3.5 0 0 1 0 10.5L0 3.5A3.5 3.5 0 0 1 3.5 0",
    transform: "translate(285.5789 5)",
    fill: "#ee6666"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    x: 30,
    y: 7,
    transform: "translate(285.5789 5)",
    fill: "#333"
  }, "bar4"));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedbarchartThumb);
export default __webpack_public_path__ + "static/media/stackedbarchart_thumb.6e12c2ae00d9656aa853217290dfcdb5.svg";
export { ForwardRef as ReactComponent };